var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-custom"},[_c('Breadscrumbs',{attrs:{"links":[
      { name: 'Dividend Historyg',
        to: {
          name: 'DividendHistory'
        }
      },
      { name: 'Create',
        to: {
          name: 'DividendHistoryCreate',
        },
      } ]}}),_c('div',{staticClass:"page-actions"},[_c('h2',[_vm._v("新增Dividend History")]),_c('v-spacer'),_c('button',{staticClass:"btn mr-5",on:{"click":_vm.cancelHandler}},[_vm._v("取消")]),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.saveHandler}},[_vm._v("儲存")])],1),_c('DividendHistoryCreateEdit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }